import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import wfLogo from "../../assets/images/wf-logo.svg";
import MainContainer from "../MainContainer";
import styles from "./Footer.module.scss";
import withTheme from "../../libs/themr/withTheme";

const Footer = ({ className, theme, menu, handleLinkClick, homeUrl, translate }) => {
  const { navigation, contact } = menu;

  return (
    <footer className={cx(className, theme.footerMain)}>
      <MainContainer>
        <div className={theme.footerWrap}>
          <nav className={theme.navigationBar}>
            <a
              className={theme.footerLink}
              href={homeUrl}
              onClick={event => handleLinkClick(event, homeUrl, "_self", true)}
            >
              {translate && translate("home")}
              {!translate && "Home"}
            </a>
            {contact && (
              <a
                className={theme.footerLink}
                href={`mailTo:${contact.recipient}`}
                onClick={event => handleLinkClick(event, `mailTo:${contact.recipient}`)}
              >
                {contact.title}
              </a>
            )}
            {navigation.map(n => {
              const { id, title, url, isInternalLink, target } = n;
              return (
                <a
                  key={id}
                  className={theme.footerLink}
                  href={url}
                  target={target}
                  onClick={event => handleLinkClick(event, url, target, isInternalLink)}
                >
                  {title}
                </a>
              );
            })}
          </nav>
          <a href="https://webbfontaine.com" className={theme.logoBox}>
            <img src={wfLogo} alt="Webb Fontaine LLC" />
          </a>
        </div>
      </MainContainer>
    </footer>
  );
};

Footer.defaultProps = {
  className: "",
  handleLinkClick: () => {},
  homeUrl: "/",
  translate: null
};

Footer.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.object.isRequired,
  menu: PropTypes.shape({
    contact: PropTypes.shape({
      recipient: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    }),
    navigation: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        target: PropTypes.string,
        isInternalLink: PropTypes.bool
      })
    ).isRequired
  }).isRequired,
  handleLinkClick: PropTypes.func,
  homeUrl: PropTypes.string,
  translate: PropTypes.func
};

export default withTheme(styles)(Footer);
